import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const SubscriptionConfirmedPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const sessionId = searchParams?.get('session_id');
    if (!sessionId) {
      navigate('/pricing');
      return;
    }

    setTimeout(() => setLoading(false), 1500);
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <div className="text-center">
          <Icon name="Loader2" size={48} className="animate-spin text-blue-600 mx-auto mb-4" />
          <p className="text-gray-600">Confirmando sua assinatura...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-12 text-center">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Icon name="CheckCircle2" size={48} className="text-green-600" />
          </div>

          {/* Success Message */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Assinatura Confirmada!
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Bem-vindo à Vertex Commerce. Sua jornada estratégica começa agora.
          </p>

          {/* Benefits */}
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 mb-8">
            <h2 className="text-lg font-bold text-gray-900 mb-4">O que você pode fazer agora:</h2>
            <div className="grid md:grid-cols-2 gap-4 text-left">
              <div className="flex items-start gap-3">
                <Icon name="Check" size={20} className="text-green-600 mt-1 flex-shrink-0" />
                <p className="text-gray-700">Importar produtos do CSV</p>
              </div>
              <div className="flex items-start gap-3">
                <Icon name="Check" size={20} className="text-green-600 mt-1 flex-shrink-0" />
                <p className="text-gray-700">Criar kits inteligentes</p>
              </div>
              <div className="flex items-start gap-3">
                <Icon name="Check" size={20} className="text-green-600 mt-1 flex-shrink-0" />
                <p className="text-gray-700">Simular precificação</p>
              </div>
              <div className="flex items-start gap-3">
                <Icon name="Check" size={20} className="text-green-600 mt-1 flex-shrink-0" />
                <p className="text-gray-700">Gerar descrições com IA</p>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="xl" onClick={() => navigate('/dashboard-overview')}>
              <Icon name="LayoutDashboard" size={20} />
              Ir para Dashboard
            </Button>
            <Button size="xl" variant="outline" onClick={() => navigate('/my-subscription')}>
              <Icon name="CreditCard" size={20} />
              Ver Minha Assinatura
            </Button>
          </div>

          {/* Additional Info */}
          <p className="text-sm text-gray-500 mt-8">
            Um e-mail de confirmação foi enviado para você com todos os detalhes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionConfirmedPage;